import { action } from '@ember/object';
import Ember from 'ember';
import Route from 'cio/routes/base';
import isDestroyed from 'cio/utils/is-destroyed';
import moment from 'moment-timezone';
import { inject as service } from '@ember/service';

export default class IndexRoute extends Route {
  @service analytics;
  @service store;

  queryParams = {
    page: {
      refreshModel: true,
    },
  };

  model(params) {
    let parentParams = this.paramsFor('broadcasts.broadcast');
    return this.store.query('broadcastTrigger', {
      ...params,
      ...parentParams,
    });
  }

  beforeModel() {
    let campaign = this.modelFor('broadcasts.broadcast');
    if (!campaign.isApiTriggered) {
      this.router.transitionTo('campaigns.campaign.overview');
    }
    return campaign.reload();
  }

  setupController(controller) {
    super.setupController(...arguments);

    controller.set('testing', Ember.testing);
  }

  @action
  didTransition() {
    this.analytics.track('broadcast', 'broadcasts_tab_viewed', {
      model: this.modelFor('broadcasts.broadcast'),
    });
    return true;
  }

  @action
  reloadModelSetLastUpdated() {
    return this.refresh().then(() => {
      if (isDestroyed(this.controller)) {
        return;
      }

      this.controller.set('lastUpdated', moment().unix());
    });
  }
}
